export const WOJ = {
  pathWojewodztwa: [
    { lng: 21.59496026639006, lat: 53.48478119745215 },
    { lng: 21.4366232535953, lat: 53.46270929024098 },
    { lng: 21.43339792163621, lat: 53.43575539983706 },
    { lng: 21.28773863130105, lat: 53.41228787526563 },
    { lng: 21.2818064788638, lat: 53.4256265390963 },
    { lng: 21.1429267295191, lat: 53.37677306615285 },
    { lng: 21.05683262114992, lat: 53.33409578024776 },
    { lng: 21.00464109369794, lat: 53.35667031014145 },
    { lng: 20.94282061182008, lat: 53.35529968747029 },
    { lng: 20.85690522628937, lat: 53.2991579856384 },
    { lng: 20.7377072482895, lat: 53.31331698207515 },
    { lng: 20.66337427228602, lat: 53.25737061455391 },
    { lng: 20.58087476046298, lat: 53.2350546625261 },
    { lng: 20.53095664769758, lat: 53.2270484574679 },
    { lng: 20.45542419965078, lat: 53.25560608379828 },
    { lng: 20.32815431193941, lat: 53.16772673645229 },
    { lng: 20.24528247141945, lat: 53.15199502146752 },
    { lng: 20.10874279624263, lat: 53.16856252736049 },
    { lng: 20.00368976088694, lat: 53.14869831848817 },
    { lng: 19.91222245758207, lat: 53.21720131856446 },
    { lng: 19.74949185700898, lat: 53.14678438027854 },
    { lng: 19.71551983859503, lat: 53.1375956020197 },
    { lng: 19.6362166179277, lat: 53.11143814623188 },
    { lng: 19.63872596744302, lat: 53.09780056382236 },
    { lng: 19.64941486693352, lat: 53.05270785098607 },
    { lng: 19.65217790124992, lat: 53.03566212448914 },
    { lng: 19.68476331110616, lat: 53.01944336564033 },
    { lng: 19.66638276065829, lat: 52.98128042276574 },
    { lng: 19.68466149435955, lat: 52.96552946948697 },
    { lng: 19.67410636229494, lat: 52.95496933425351 },
    { lng: 19.64454436353091, lat: 52.96954717905125 },
    { lng: 19.58094737126479, lat: 52.98230275000898 },
    { lng: 19.55889209849706, lat: 52.9910903468907 },
    { lng: 19.5691234680369, lat: 52.97164250727405 },
    { lng: 19.58447159086362, lat: 52.95517139338291 },
    { lng: 19.52863128079241, lat: 52.94198928041893 },
    { lng: 19.49198442263246, lat: 52.93824658645028 },
    { lng: 19.44555948704019, lat: 52.94674419466131 },
    { lng: 19.44360363736711, lat: 52.9370708655353 },
    { lng: 19.44787771485578, lat: 52.9252625489181 },
    { lng: 19.47166262744929, lat: 52.91701856043095 },
    { lng: 19.46406015285583, lat: 52.91579831899593 },
    { lng: 19.45817676568576, lat: 52.9070034544399 },
    { lng: 19.51581467242233, lat: 52.86030742608091 },
    { lng: 19.49563511583648, lat: 52.86534767904453 },
    { lng: 19.47423098438961, lat: 52.86504264713082 },
    { lng: 19.46476497373623, lat: 52.85978541024784 },
    { lng: 19.46357567366796, lat: 52.85411189447559 },
    { lng: 19.47047368114668, lat: 52.85033877526857 },
    { lng: 19.45709286532772, lat: 52.84595705959771 },
    { lng: 19.44450178350579, lat: 52.83861116244536 },
    { lng: 19.4261975492503, lat: 52.84070991427983 },
    { lng: 19.42391315247932, lat: 52.83396806879771 },
    { lng: 19.43130355366112, lat: 52.82504866988987 },
    { lng: 19.42478615617963, lat: 52.81607865786591 },
    { lng: 19.43648720132172, lat: 52.81350506627987 },
    { lng: 19.45303450981661, lat: 52.80339921832351 },
    { lng: 19.46458062905901, lat: 52.80264686413473 },
    { lng: 19.46338702698953, lat: 52.78762639200825 },
    { lng: 19.47347522976471, lat: 52.78244471389122 },
    { lng: 19.49199729196028, lat: 52.7775122444384 },
    { lng: 19.49186562299142, lat: 52.77166157476583 },
    { lng: 19.50312185992722, lat: 52.76687825357037 },
    { lng: 19.49912440824065, lat: 52.75652912611456 },
    { lng: 19.49922678904343, lat: 52.74776285151327 },
    { lng: 19.52036227872516, lat: 52.74765426960538 },
    { lng: 19.51474936703555, lat: 52.74237406314368 },
    { lng: 19.49956404940666, lat: 52.73608064751084 },
    { lng: 19.50066492707801, lat: 52.72990172488157 },
    { lng: 19.503864261991, lat: 52.72013087569764 },
    { lng: 19.50399533635081, lat: 52.71100010748636 },
    { lng: 19.52621041491255, lat: 52.70471058991995 },
    { lng: 19.51718596447204, lat: 52.70444586625682 },
    { lng: 19.49282809554194, lat: 52.7073816817988 },
    { lng: 19.49467631481808, lat: 52.71437878110802 },
    { lng: 19.48228826581401, lat: 52.7183964103877 },
    { lng: 19.46896085136821, lat: 52.71909626398926 },
    { lng: 19.4576541060669, lat: 52.72460507527003 },
    { lng: 19.44209580567562, lat: 52.72304287509049 },
    { lng: 19.43824125456577, lat: 52.71854231508991 },
    { lng: 19.43943970791831, lat: 52.71127029339636 },
    { lng: 19.44611136311231, lat: 52.70343168059503 },
    { lng: 19.43677986104897, lat: 52.69218845348316 },
    { lng: 19.43605467176956, lat: 52.68125601085662 },
    { lng: 19.44360597006848, lat: 52.68211085668961 },
    { lng: 19.44732454352681, lat: 52.67710580600129 },
    { lng: 19.45033696754671, lat: 52.67210280564098 },
    { lng: 19.44632229556559, lat: 52.67063493170978 },
    { lng: 19.44610974655816, lat: 52.67311736612155 },
    { lng: 19.44344751490917, lat: 52.6759480477302 },
    { lng: 19.44010767108638, lat: 52.67657650514244 },
    { lng: 19.43319016383321, lat: 52.6765765875837 },
    { lng: 19.43207809836366, lat: 52.67176119748544 },
    { lng: 19.42382749644943, lat: 52.67140834007252 },
    { lng: 19.41977807284164, lat: 52.67221974864986 },
    { lng: 19.41503001654207, lat: 52.67134946134746 },
    { lng: 19.41284073745857, lat: 52.66652372351393 },
    { lng: 19.41381997171135, lat: 52.66135463378475 },
    { lng: 19.41106312476754, lat: 52.66033614947008 },
    { lng: 19.40999499573158, lat: 52.65881453431734 },
    { lng: 19.40996449770442, lat: 52.65431596448242 },
    { lng: 19.40910388129282, lat: 52.65420419860165 },
    { lng: 19.4049731796023, lat: 52.65080476701886 },
    { lng: 19.4036022010965, lat: 52.64825584945427 },
    { lng: 19.40407289337082, lat: 52.64628720206879 },
    { lng: 19.40314179597869, lat: 52.64447329924184 },
    { lng: 19.39949058843944, lat: 52.64462574748994 },
    { lng: 19.39213990371793, lat: 52.64393115208357 },
    { lng: 19.3832427716901, lat: 52.64391325845965 },
    { lng: 19.38055828312363, lat: 52.64100281945954 },
    { lng: 19.38047971445368, lat: 52.63897898181311 },
    { lng: 19.37273184140165, lat: 52.63753711762189 },
    { lng: 19.37264789081621, lat: 52.6337021076083 },
    { lng: 19.36303907791734, lat: 52.62570670878991 },
    { lng: 19.37257392665725, lat: 52.62442023931651 },
    { lng: 19.40909183336033, lat: 52.61667211634522 },
    { lng: 19.40990863835637, lat: 52.6112901341895 },
    { lng: 19.42293767973244, lat: 52.60614612917816 },
    { lng: 19.41920212495017, lat: 52.59933056163769 },
    { lng: 19.41580991073072, lat: 52.59895837771662 },
    { lng: 19.41381368447903, lat: 52.59609693191315 },
    { lng: 19.39906891772875, lat: 52.5943301584385 },
    { lng: 19.39484467287384, lat: 52.58687866400778 },
    { lng: 19.39624459400834, lat: 52.5794245263342 },
    { lng: 19.38658622692906, lat: 52.5719605533262 },
    { lng: 19.37737982580031, lat: 52.56860442581062 },
    { lng: 19.36365135910664, lat: 52.56954118998235 },
    { lng: 19.35732577165065, lat: 52.56832594407156 },
    { lng: 19.35030058504452, lat: 52.5691294224119 },
    { lng: 19.34151767832607, lat: 52.56761158395965 },
    { lng: 19.34608135209654, lat: 52.52417452953991 },
    { lng: 19.35971912125079, lat: 52.52046446706002 },
    { lng: 19.37359877884554, lat: 52.52002683432236 },
    { lng: 19.3846875716046, lat: 52.51843423608923 },
    { lng: 19.3934732212421, lat: 52.51256304852003 },
    { lng: 19.38189229634774, lat: 52.50846274914235 },
    { lng: 19.37293787198936, lat: 52.50756945353212 },
    { lng: 19.36292515935283, lat: 52.50377346892672 },
    { lng: 19.36299382510518, lat: 52.4999232802866 },
    { lng: 19.35327740376806, lat: 52.48991761921978 },
    { lng: 19.35802436686718, lat: 52.48176003577775 },
    { lng: 19.33858032421113, lat: 52.47932280853087 },
    { lng: 19.33080685336568, lat: 52.4711493743493 },
    { lng: 19.33282848571356, lat: 52.46682159667962 },
    { lng: 19.32017003568654, lat: 52.45490223699085 },
    { lng: 19.31895109646118, lat: 52.44851041580118 },
    { lng: 19.30398369731626, lat: 52.44820783042363 },
    { lng: 19.29959274117342, lat: 52.44551477906252 },
    { lng: 19.2824553802887, lat: 52.44963837308736 },
    { lng: 19.26694545779367, lat: 52.44818276380074 },
    { lng: 19.25965643025976, lat: 52.44205576210594 },
    { lng: 19.26181303018594, lat: 52.43546283854904 },
    { lng: 19.28331904086194, lat: 52.43220656491893 },
    { lng: 19.28927419875017, lat: 52.43090027853427 },
    { lng: 19.29603454748055, lat: 52.42423626400667 },
    { lng: 19.29731659075611, lat: 52.41720327789858 },
    { lng: 19.29256569684178, lat: 52.41845047567534 },
    { lng: 19.29211087052393, lat: 52.41101193980743 },
    { lng: 19.28059141466265, lat: 52.40505918857588 },
    { lng: 19.28435202464537, lat: 52.4011198138113 },
    { lng: 19.2869582040457, lat: 52.40138729869038 },
    { lng: 19.28991555313126, lat: 52.39740231552915 },
    { lng: 19.28699337250454, lat: 52.39749565729576 },
    { lng: 19.28907337482972, lat: 52.3926594923415 },
    { lng: 19.30215329651631, lat: 52.39092202398204 },
    { lng: 19.30131521156022, lat: 52.38702797710638 },
    { lng: 19.30846313657064, lat: 52.38724835953282 },
    { lng: 19.30753062160278, lat: 52.38070725006325 },
    { lng: 19.2918412985342, lat: 52.37721003386658 },
    { lng: 19.29454862407757, lat: 52.37027700207616 },
    { lng: 19.30085538670585, lat: 52.36824070307794 },
    { lng: 19.31663166835095, lat: 52.37063855822512 },
    { lng: 19.32388379642333, lat: 52.36784490774465 },
    { lng: 19.32800672950943, lat: 52.36025087114768 },
    { lng: 19.3275830321474, lat: 52.35427919221338 },
    { lng: 19.32327538107537, lat: 52.34822976803079 },
    { lng: 19.33270260972873, lat: 52.34866213313482 },
    { lng: 19.33386570714568, lat: 52.34657814607332 },
    { lng: 19.34924448510656, lat: 52.34662925444902 },
    { lng: 19.35844751438607, lat: 52.34098108834333 },
    { lng: 19.37691044631536, lat: 52.33996615777451 },
    { lng: 19.38279827960512, lat: 52.34243498516413 },
    { lng: 19.40483061973559, lat: 52.34397028362228 },
    { lng: 19.40659584030269, lat: 52.33916730704403 },
    { lng: 19.42564428077005, lat: 52.33748439628496 },
    { lng: 19.4405223915473, lat: 52.3384997253596 },
    { lng: 19.45027872524307, lat: 52.35144316814848 },
    { lng: 19.4628675695568, lat: 52.34229433555736 },
    { lng: 19.50285241241805, lat: 52.3322805068068 },
    { lng: 19.4924477804034, lat: 52.3197747033151 },
    { lng: 19.51174783403154, lat: 52.30935042039312 },
    { lng: 19.51842417018366, lat: 52.30367441333142 },
    { lng: 19.53620215627433, lat: 52.30344263155202 },
    { lng: 19.54808179185825, lat: 52.29580725011471 },
    { lng: 19.57870985468603, lat: 52.28890935133094 },
    { lng: 19.61321417869275, lat: 52.27635200788249 },
    { lng: 19.62427353415679, lat: 52.26206917966022 },
    { lng: 19.6392800441452, lat: 52.25189289814448 },
    { lng: 19.68816901632146, lat: 52.25561777486293 },
    { lng: 19.73585236889738, lat: 52.26233742262771 },
    { lng: 19.78622937371539, lat: 52.26609680448138 },
    { lng: 19.81702204210737, lat: 52.27927464338821 },
    { lng: 19.8390338869458, lat: 52.27221416745578 },
    { lng: 19.87251169322284, lat: 52.27932829704083 },
    { lng: 19.88191034714582, lat: 52.28812277330184 },
    { lng: 19.86917241210932, lat: 52.29087708517941 },
    { lng: 19.88695825246074, lat: 52.30793143141624 },
    { lng: 19.91131300188546, lat: 52.29992431167346 },
    { lng: 19.93559327660691, lat: 52.29511642782956 },
    { lng: 19.95783649629614, lat: 52.27790054317556 },
    { lng: 19.99109573238785, lat: 52.26131690263023 },
    { lng: 20.03762908992642, lat: 52.25487351667007 },
    { lng: 20.07189194375335, lat: 52.23648872175469 },
    { lng: 20.07529760334775, lat: 52.21432384192175 },
    { lng: 20.05847958889335, lat: 52.18809341088541 },
    { lng: 20.08494541475119, lat: 52.15372896162472 },
    { lng: 20.12033779751529, lat: 52.14480796610578 },
    { lng: 20.15768606880982, lat: 52.14584542622691 },
    { lng: 20.20355552003345, lat: 52.11355547835454 },
    { lng: 20.25284036056506, lat: 52.11415955551021 },
    { lng: 20.26675387143491, lat: 52.09784006799494 },
    { lng: 20.26552450701221, lat: 52.07717116689085 },
    { lng: 20.24298729107205, lat: 52.07516023904202 },
    { lng: 20.24856278407258, lat: 52.05240497915125 },
    { lng: 20.19923131069947, lat: 52.02605546195976 },
    { lng: 20.24373020611358, lat: 51.9990086003838 },
    { lng: 20.26055551327747, lat: 51.99301177610235 },
    { lng: 20.27088728027425, lat: 51.97108849978813 },
    { lng: 20.28954643983241, lat: 51.96658154465784 },
    { lng: 20.25408344166186, lat: 51.95389351478533 },
    { lng: 20.24008377144071, lat: 51.94273159201364 },
    { lng: 20.26292169806278, lat: 51.92897613534419 },
    { lng: 20.30487281720623, lat: 51.93522454241842 },
    { lng: 20.30995401664002, lat: 51.92111077823097 },
    { lng: 20.29285309984922, lat: 51.91069728492049 },
    { lng: 20.321557529345, lat: 51.91150984180504 },
    { lng: 20.4356487229443, lat: 51.93637545421016 },
    { lng: 20.47570216971478, lat: 51.92576702311995 },
    { lng: 20.47876401199629, lat: 51.89799538266345 },
    { lng: 20.49785353602259, lat: 51.88650851735998 },
    { lng: 20.56714625151067, lat: 51.88365871307716 },
    { lng: 20.61715900026117, lat: 51.81948642476667 },
    { lng: 20.59818698141288, lat: 51.81677471664516 },
    { lng: 20.55586215410514, lat: 51.8192900818526 },
    { lng: 20.56173340233881, lat: 51.80632597499955 },
    { lng: 20.57770901750854, lat: 51.80603699784708 },
    { lng: 20.58598330687713, lat: 51.78063190435306 },
    { lng: 20.59537392239596, lat: 51.76836000205758 },
    { lng: 20.58378465580764, lat: 51.74826064334333 },
    { lng: 20.63979205161507, lat: 51.73439676376152 },
    { lng: 20.65523516825164, lat: 51.71004456670591 },
    { lng: 20.65011639460385, lat: 51.67640550620715 },
    { lng: 20.63358935651966, lat: 51.67274736612724 },
    { lng: 20.61678277727233, lat: 51.65817708608821 },
    { lng: 20.53196421149823, lat: 51.66905527461427 },
    { lng: 20.52714722003902, lat: 51.6780272766585 },
    { lng: 20.51280703416852, lat: 51.68492193512549 },
    { lng: 20.47662894197621, lat: 51.68735906890505 },
    { lng: 20.46575433301391, lat: 51.69597180159776 },
    { lng: 20.44168296877126, lat: 51.69281639033161 },
    { lng: 20.42288711523245, lat: 51.67708987609682 },
    { lng: 20.41029127329516, lat: 51.6772237264928 },
    { lng: 20.3918245151661, lat: 51.66045554986115 },
    { lng: 20.38421166559476, lat: 51.64217901403685 },
    { lng: 20.40401118239515, lat: 51.63335372523409 },
    { lng: 20.41968053404677, lat: 51.62641691856432 },
    { lng: 20.41637830175751, lat: 51.60522974289498 },
    { lng: 20.43075479086917, lat: 51.59731019230411 },
    { lng: 20.43898512667759, lat: 51.58101182161707 },
    { lng: 20.4327190342515, lat: 51.57459105693378 },
    { lng: 20.43952186354149, lat: 51.57022775810204 },
    { lng: 20.45947815744709, lat: 51.57141954880523 },
    { lng: 20.46885280502144, lat: 51.55670866558886 },
    { lng: 20.45426177159181, lat: 51.53851940540742 },
    { lng: 20.45126306200169, lat: 51.50265218490575 },
    { lng: 20.49334523043802, lat: 51.49999862173758 },
    { lng: 20.52084394852055, lat: 51.50778184481337 },
    { lng: 20.52788185726306, lat: 51.45682502037133 },
    { lng: 20.49847217023974, lat: 51.45018364145388 },
    { lng: 20.49649139723624, lat: 51.44194336221009 },
    { lng: 20.48487434763082, lat: 51.43787301269466 },
    { lng: 20.49472821806809, lat: 51.42172479466621 },
    { lng: 20.47338168139474, lat: 51.40939882522242 },
    { lng: 20.45113774840211, lat: 51.41076770070697 },
    { lng: 20.44008720480251, lat: 51.39454620193226 },
    { lng: 20.42807204235356, lat: 51.37746686634749 },
    { lng: 20.41864566179184, lat: 51.36193031091487 },
    { lng: 20.42205938012201, lat: 51.36068880454625 },
    { lng: 20.42306112484928, lat: 51.35376772120419 },
    { lng: 20.42737621180028, lat: 51.35029011076367 },
    { lng: 20.42952815817106, lat: 51.34684606539354 },
    { lng: 20.4308040098559, lat: 51.33779900158955 },
    { lng: 20.42159712609666, lat: 51.32855232331838 },
    { lng: 20.41011388988696, lat: 51.32598096417914 },
    { lng: 20.41231304536344, lat: 51.32042751843881 },
    { lng: 20.38552561507264, lat: 51.31854373778667 },
    { lng: 20.36286194833011, lat: 51.30947426531583 },
    { lng: 20.39079897661443, lat: 51.27097981502216 },
    { lng: 20.37319658910597, lat: 51.26655059380971 },
    { lng: 20.38011790768989, lat: 51.24542642460143 },
    { lng: 20.36907077812115, lat: 51.23725732948699 },
    { lng: 20.35739929059826, lat: 51.24982720939076 },
    { lng: 20.3310568562125, lat: 51.25468088880478 },
    { lng: 20.30523792660283, lat: 51.24046890587522 },
    { lng: 20.26292792615968, lat: 51.25494360338111 },
    { lng: 20.2536431436003, lat: 51.25915979295906 },
    { lng: 20.24039782065302, lat: 51.25652520095859 },
    { lng: 20.24231979464174, lat: 51.24311587497728 },
    { lng: 20.2510480121304, lat: 51.22261600899324 },
    { lng: 20.26236409448203, lat: 51.21509560340012 },
    { lng: 20.24866264489317, lat: 51.20683955046793 },
    { lng: 20.21952305568737, lat: 51.20148962877006 },
    { lng: 20.21360567524149, lat: 51.20860571422392 },
    { lng: 20.20701576720393, lat: 51.20111726163886 },
    { lng: 20.19548724757018, lat: 51.19965105573064 },
    { lng: 20.18143598591669, lat: 51.20764425533984 },
    { lng: 20.17774742610909, lat: 51.19743623695925 },
    { lng: 20.15998276140633, lat: 51.19762480095887 },
    { lng: 20.15560607421028, lat: 51.18920146230089 },
    { lng: 20.11133596906384, lat: 51.19332878824576 },
    { lng: 20.06660138880581, lat: 51.19545729469964 },
    { lng: 20.05946244461502, lat: 51.19838519644032 },
    { lng: 20.05288490223706, lat: 51.20212008021934 },
    { lng: 20.02127896536442, lat: 51.1971611511036 },
    { lng: 20.0022020354106, lat: 51.19260278795539 },
    { lng: 19.99359662108622, lat: 51.18286204033205 },
    { lng: 20.02334840351772, lat: 51.16411296787216 },
    { lng: 20.01289931415943, lat: 51.15392962048411 },
    { lng: 19.99038476007966, lat: 51.13824328516185 },
    { lng: 19.98406617876941, lat: 51.13134825457153 },
    { lng: 19.9836827344672, lat: 51.11323530736095 },
    { lng: 19.99191223739637, lat: 51.10445240840904 },
    { lng: 19.98198535275473, lat: 51.07307347956393 },
    { lng: 20.04619504445114, lat: 51.06725659799514 },
    { lng: 20.05442700370734, lat: 51.0580839274955 },
    { lng: 20.04847775054031, lat: 51.05435981043892 },
    { lng: 20.05030070390701, lat: 51.01591991291339 },
    { lng: 20.04290224796886, lat: 50.99919519556376 },
    { lng: 20.0324523516946, lat: 50.99729615547598 },
    { lng: 20.03504844234511, lat: 50.9726454739574 },
    { lng: 20.01653354006374, lat: 50.96264258442698 },
    { lng: 19.95696379672815, lat: 50.99018439276256 },
    { lng: 19.95474862147502, lat: 51.00402260063148 },
    { lng: 19.93693478005315, lat: 51.02438818546859 },
    { lng: 19.8853052051109, lat: 51.04682339061363 },
    { lng: 19.86769023445145, lat: 51.04496025194008 },
    { lng: 19.86712433410033, lat: 51.03437787341074 },
    { lng: 19.86128007434925, lat: 51.01719499230222 },
    { lng: 19.86159603596198, lat: 51.00481031410395 },
    { lng: 19.8449231694466, lat: 50.99507838172585 },
    { lng: 19.82843870919098, lat: 50.96607935733666 },
    { lng: 19.83354238733594, lat: 50.94881493722391 },
    { lng: 19.844399833324, lat: 50.94091746974198 },
    { lng: 19.83757995306455, lat: 50.91821482351397 },
    { lng: 19.80510494129874, lat: 50.90658409392538 },
    { lng: 19.79811125358135, lat: 50.91185388449588 },
    { lng: 19.78450293889806, lat: 50.90084780076798 },
    { lng: 19.77511032850441, lat: 50.8831027815628 },
    { lng: 19.75348206427986, lat: 50.86402477443788 },
    { lng: 19.77004569816809, lat: 50.85724732108635 },
    { lng: 19.81222882068838, lat: 50.83939928582819 },
    { lng: 19.82743953005898, lat: 50.8224740635485 },
    { lng: 19.81753499685121, lat: 50.81939229719653 },
    { lng: 19.82066147434553, lat: 50.8080269935199 },
    { lng: 19.80942732649579, lat: 50.80352343478256 },
    { lng: 19.79147734493322, lat: 50.81852100616336 },
    { lng: 19.77993463657186, lat: 50.8176739552642 },
    { lng: 19.77857350613106, lat: 50.80799383716251 },
    { lng: 19.76840307796475, lat: 50.78369553997984 },
    { lng: 19.74634683616797, lat: 50.7604969450586 },
    { lng: 19.72756032625861, lat: 50.7730501962223 },
    { lng: 19.71070465899634, lat: 50.76256229771131 },
    { lng: 19.70211817433891, lat: 50.753018846862 },
    { lng: 19.71625618780702, lat: 50.73370073259922 },
    { lng: 19.70925335255835, lat: 50.73015357378001 },
    { lng: 19.71889086461462, lat: 50.71463505398555 },
    { lng: 19.7595334452759, lat: 50.71472217992372 },
    { lng: 19.78950512850199, lat: 50.71773011729717 },
    { lng: 19.83229852992822, lat: 50.70398134910136 },
    { lng: 19.8522765431026, lat: 50.68890899331439 },
    { lng: 19.87028838699856, lat: 50.69142773772236 },
    { lng: 19.87111581462431, lat: 50.6818268296767 },
    { lng: 19.85865452980843, lat: 50.67371533004856 },
    { lng: 19.86447326667005, lat: 50.66492370940844 },
    { lng: 19.84002966729172, lat: 50.66668283511353 },
    { lng: 19.83205745066881, lat: 50.65358624996674 },
    { lng: 19.87032049881746, lat: 50.64394725538335 },
    { lng: 19.88997030131631, lat: 50.63882164089618 },
    { lng: 19.92026792092141, lat: 50.63917163681843 },
    { lng: 19.89775151220906, lat: 50.61855949247843 },
    { lng: 19.85912941213617, lat: 50.6211336491852 },
    { lng: 19.83482688035912, lat: 50.58635219738357 },
    { lng: 19.80430254290162, lat: 50.56546317947039 },
    { lng: 19.7910445384035, lat: 50.56693885778792 },
    { lng: 19.78907426692767, lat: 50.55469690879304 },
    { lng: 19.8425356598908, lat: 50.55521126217833 },
    { lng: 19.86517784152381, lat: 50.53802867001641 },
    { lng: 19.90032245496496, lat: 50.53983197974983 },
    { lng: 19.91127895333967, lat: 50.50497117751441 },
    { lng: 19.95066425643714, lat: 50.50369973120991 },
    { lng: 19.98071152249036, lat: 50.51812006605891 },
    { lng: 20.03753473754851, lat: 50.50009473562034 },
    { lng: 20.09455210706058, lat: 50.49165223459887 },
    { lng: 20.11827953686698, lat: 50.48407106464447 },
    { lng: 20.13719827319001, lat: 50.48657829632656 },
    { lng: 20.16750030243069, lat: 50.48495097229942 },
    { lng: 20.20204759180591, lat: 50.49368692517867 },
    { lng: 20.23942712896685, lat: 50.4781702931336 },
    { lng: 20.24549063182796, lat: 50.46426815698069 },
    { lng: 20.27153111306991, lat: 50.4656842919992 },
    { lng: 20.26023552715343, lat: 50.44166211551825 },
    { lng: 20.26551976524015, lat: 50.4245344142522 },
    { lng: 20.28718215520939, lat: 50.41685182809519 },
    { lng: 20.30741353652083, lat: 50.38735253324661 },
    { lng: 20.32601951983801, lat: 50.36612091890096 },
    { lng: 20.34264458200738, lat: 50.35827444719465 },
    { lng: 20.299000625278, lat: 50.3512470894427 },
    { lng: 20.29059658386372, lat: 50.34267593481336 },
    { lng: 20.30416674457317, lat: 50.33538587428979 },
    { lng: 20.2848970526417, lat: 50.32457524513043 },
    { lng: 20.29536822072755, lat: 50.31847532086848 },
    { lng: 20.32447802846423, lat: 50.31803770346701 },
    { lng: 20.33532612204889, lat: 50.29271962977159 },
    { lng: 20.35802075038812, lat: 50.28375289123389 },
    { lng: 20.32898324666795, lat: 50.26946429704551 },
    { lng: 20.39539258304083, lat: 50.23735298787179 },
    { lng: 20.37544174932245, lat: 50.22545442042034 },
    { lng: 20.38452665732516, lat: 50.20699166279831 },
    { lng: 20.40998014983325, lat: 50.21001830608083 },
    { lng: 20.416013530215, lat: 50.19222962917262 },
    { lng: 20.45746917111818, lat: 50.19684687706632 },
    { lng: 20.49830445754889, lat: 50.19340400842191 },
    { lng: 20.51499541070536, lat: 50.18507425992166 },
    { lng: 20.5402895285068, lat: 50.19073972597796 },
    { lng: 20.55706835315961, lat: 50.19884540526373 },
    { lng: 20.57525986453994, lat: 50.18595544362107 },
    { lng: 20.6212909959903, lat: 50.20401983601517 },
    { lng: 20.64983565176959, lat: 50.20669068839288 },
    { lng: 20.67590126641851, lat: 50.20163586585592 },
    { lng: 20.68164268685025, lat: 50.21479824394667 },
    { lng: 20.70070782052837, lat: 50.21644415195687 },
    { lng: 20.71022448272288, lat: 50.22702813075137 },
    { lng: 20.72971499789286, lat: 50.23174574975894 },
    { lng: 20.7310314848914, lat: 50.24901380903567 },
    { lng: 20.75463135762217, lat: 50.26533391847094 },
    { lng: 20.77458166387051, lat: 50.27313226027528 },
    { lng: 20.79173073920206, lat: 50.28776018015135 },
    { lng: 20.81474739587084, lat: 50.28528534669651 },
    { lng: 20.83415952031308, lat: 50.27274117075224 },
    { lng: 20.85082341042385, lat: 50.27948061610544 },
    { lng: 20.8560909818221, lat: 50.29442788360554 },
    { lng: 20.91131350909239, lat: 50.30172411082464 },
    { lng: 20.93809499570238, lat: 50.29348838719306 },
    { lng: 20.96319005381189, lat: 50.31385565147794 },
    { lng: 21.06383526745522, lat: 50.31328193789282 },
    { lng: 21.11495366947162, lat: 50.34115346500227 },
    { lng: 21.14538370750644, lat: 50.35173695679262 },
    { lng: 21.18848595895238, lat: 50.32898015396579 },
    { lng: 21.20731432520475, lat: 50.35412257048101 },
    { lng: 21.21901861835126, lat: 50.3088934671229 },
    { lng: 21.17811817132012, lat: 50.2911797750969 },
    { lng: 21.1455144248347, lat: 50.25535716437504 },
    { lng: 21.18110876438355, lat: 50.24011323490027 },
    { lng: 21.14074293920032, lat: 50.2367489907763 },
    { lng: 21.16189649816463, lat: 50.22056857498023 },
    { lng: 21.16781575519493, lat: 50.16518804332728 },
    { lng: 21.15233034151067, lat: 50.14881258095669 },
    { lng: 21.17401100189146, lat: 50.1400295591274 },
    { lng: 21.17187973892376, lat: 50.13553839292658 },
    { lng: 21.15439304157978, lat: 50.13699477791722 },
    { lng: 21.14917307666762, lat: 50.12644698766167 },
    { lng: 21.18253849002901, lat: 50.12088889529004 },
    { lng: 21.17617243782644, lat: 50.10994638426517 },
    { lng: 21.19488768445114, lat: 50.09623113778751 },
    { lng: 21.16111826351774, lat: 50.08838877464018 },
    { lng: 21.17346048229108, lat: 50.07453483339692 },
    { lng: 21.16642609463579, lat: 50.06544768958571 },
    { lng: 21.16212412835906, lat: 50.05939927079098 },
    { lng: 21.14171979400265, lat: 50.05149594113304 },
    { lng: 21.17374354919506, lat: 50.03735340516448 },
    { lng: 21.18985078850243, lat: 50.02842143360855 },
    { lng: 21.1489258308462, lat: 49.99404773623642 },
    { lng: 21.14878798540746, lat: 49.97546464013467 },
    { lng: 21.16025652579346, lat: 49.96643210272102 },
    { lng: 21.15895043815912, lat: 49.95859933291677 },
    { lng: 21.16246030552486, lat: 49.94715794495156 },
    { lng: 21.17147307735821, lat: 49.94066881510138 },
    { lng: 21.17973167867923, lat: 49.92672849291046 },
    { lng: 21.18784389065944, lat: 49.9261630652387 },
    { lng: 21.19273448532938, lat: 49.93184523869144 },
    { lng: 21.21894778642612, lat: 49.92758255102395 },
    { lng: 21.25177849673894, lat: 49.92940123270891 },
    { lng: 21.25772563614594, lat: 49.92618101615366 },
    { lng: 21.28320431005999, lat: 49.92522985506745 },
    { lng: 21.28515160693462, lat: 49.8988629252685 },
    { lng: 21.26784595349081, lat: 49.88734461251957 },
    { lng: 21.22590838968163, lat: 49.8834873509294 },
    { lng: 21.22295481925964, lat: 49.8521817687858 },
    { lng: 21.25086898081641, lat: 49.83907981788022 },
    { lng: 21.29382932533523, lat: 49.84081922258486 },
    { lng: 21.34452802077187, lat: 49.81492926341976 },
    { lng: 21.31109615135862, lat: 49.80034339329697 },
    { lng: 21.27789691522171, lat: 49.80617432336536 },
    { lng: 21.2401304696105, lat: 49.77840529151646 },
    { lng: 21.25298776128966, lat: 49.75008937338531 },
    { lng: 21.27718678201879, lat: 49.74652180954102 },
    { lng: 21.31527372744242, lat: 49.74323889153052 },
    { lng: 21.32125984953134, lat: 49.70004375356406 },
    { lng: 21.34454819034752, lat: 49.68907707358233 },
    { lng: 21.33988672654544, lat: 49.65626839389716 },
    { lng: 21.35982406739588, lat: 49.63621999908742 },
    { lng: 21.32810136051749, lat: 49.58973758191564 },
    { lng: 21.37085269156437, lat: 49.56684755795111 },
    { lng: 21.36058059554051, lat: 49.54533787275716 },
    { lng: 21.39298941992806, lat: 49.5271228901949 },
    { lng: 21.38885213384769, lat: 49.48755817688636 },
    { lng: 21.40697436168826, lat: 49.47052787640536 },
    { lng: 21.39044848809842, lat: 49.45558364252854 },
    { lng: 21.39142455563889, lat: 49.43595473518998 },
    { lng: 21.41280048496848, lat: 49.4223659845112 },
    { lng: 21.42961019783626, lat: 49.41373185122369 },
    { lng: 21.4744429102138, lat: 49.41408469185608 },
    { lng: 21.57034598984873, lat: 49.4300244131289 },
    { lng: 21.63476033229211, lat: 49.43800389063879 },
    { lng: 21.68710497276519, lat: 49.40640192899069 },
    { lng: 21.75355139358459, lat: 49.38793951042636 },
    { lng: 21.78096730173485, lat: 49.35189136085951 },
    { lng: 21.79656925331917, lat: 49.37183315317627 },
    { lng: 21.81241776562348, lat: 49.38615983165855 },
    { lng: 21.84609507873298, lat: 49.38786041733819 },
    { lng: 21.85465884371481, lat: 49.3683244260586 },
    { lng: 21.89575508435659, lat: 49.35775587670513 },
    { lng: 21.95184686347023, lat: 49.34064863523188 },
    { lng: 21.96925539168654, lat: 49.33866836933061 },
    { lng: 21.99947257281489, lat: 49.2957782028091 },
    { lng: 22.03233431390749, lat: 49.22864868335209 },
    { lng: 22.05544372818825, lat: 49.21561249295326 },
    { lng: 22.27951907067231, lat: 49.13505630924811 },
    { lng: 22.57149269451083, lat: 49.05021173593912 },
    { lng: 22.87399318473534, lat: 48.99961458281879 },
    { lng: 22.89010012900223, lat: 49.00976400922422 },
    { lng: 22.89471719579991, lat: 49.01982789705343 },
    { lng: 22.87878914159157, lat: 49.05355649143507 },
    { lng: 22.8896083075313, lat: 49.09440414867866 },
    { lng: 22.8556812074703, lat: 49.11293797962563 },
    { lng: 22.74979346495521, lat: 49.17846164155922 },
    { lng: 22.74073378520204, lat: 49.24744465480641 },
    { lng: 22.74557960261287, lat: 49.3450348040398 },
    { lng: 22.74904575400866, lat: 49.36587728235879 },
    { lng: 22.70224627891648, lat: 49.47670004512072 },
    { lng: 22.66677370694912, lat: 49.5340823807655 },
    { lng: 22.82802990248408, lat: 49.69136599358868 },
    { lng: 23.34272976281368, lat: 50.1395208743015 },
    { lng: 23.74128518218824, lat: 50.4012764844665 },
    { lng: 23.96138948458023, lat: 50.4066023993804 },
    { lng: 24.1314717315909, lat: 50.61950201787099 },
    { lng: 23.97647686027159, lat: 50.8118662836056 },
    { lng: 24.16378050764446, lat: 50.8472149436165 },
    { lng: 23.9682587417306, lat: 50.96722053264838 },
    { lng: 23.85951181810179, lat: 51.1577911970141 },
    { lng: 23.709811704324, lat: 51.27565324472231 },
    { lng: 23.64961311847413, lat: 51.3236803083418 },
    { lng: 23.71093746613809, lat: 51.4044037169468 },
    { lng: 23.65690895200474, lat: 51.4904529784105 },
    { lng: 23.61574781870097, lat: 51.5213794335000 },
    { lng: 23.5561853542157, lat: 51.66787437912605 },
    { lng: 23.54348404107876, lat: 51.7426299378334 },
    { lng: 23.64685301430227, lat: 51.7824754260655 },
    { lng: 23.60713040047973, lat: 51.8434604020862 },
    { lng: 23.66612090197082, lat: 51.9366408808743 },
    { lng: 23.68818971818133, lat: 52.0145364344451 },
    { lng: 23.63079932834093, lat: 52.0954377942223 },
    { lng: 23.51109845739007, lat: 52.1487114824366 },
    { lng: 23.50586577088757, lat: 52.1808189419677 },
    { lng: 23.27853013527742, lat: 52.2214073604987 },
    { lng: 23.20329905616678, lat: 52.2425256740036 },
    { lng: 23.17849502615509, lat: 52.2746876914880 },
    { lng: 22.94520239082344, lat: 52.3684571546485 },
    { lng: 22.79433965925515, lat: 52.3705657792152 },
    { lng: 22.55050275407606, lat: 52.4126069399178 },
    { lng: 22.52231285326604, lat: 52.5343497853153 },
    { lng: 22.42404507453223, lat: 52.6005264908322 },
    { lng: 22.46787572975404, lat: 52.6457579047040 },
    { lng: 22.45366306680326, lat: 52.7899985741911 },
    { lng: 22.37736370805531, lat: 52.7935268073211 },
    { lng: 22.31767596335985, lat: 52.7574293712744 },
    { lng: 22.27207104231166, lat: 52.8084447675397 },
    { lng: 22.30740263180353, lat: 52.8442759679066 },
    { lng: 22.30938596496829, lat: 52.8575733057597 },
    { lng: 22.27673843558119, lat: 52.8837121008632 },
    { lng: 22.20345201895544, lat: 52.8842349127030 },
    { lng: 22.20449365576291, lat: 52.8562240123053 },
    { lng: 22.13160182477597, lat: 52.8478640266340 },
    { lng: 22.10407005161299, lat: 52.8651790468051 },
    { lng: 22.05337191137625, lat: 52.8511852562480 },
    { lng: 22.03995011761089, lat: 52.8804920346154 },
    { lng: 22.01541065301447, lat: 52.8830852298201 },
    { lng: 22.01628992840473, lat: 52.9199884160858 },
    { lng: 22.02776271461331, lat: 52.9378683712310 },
    { lng: 21.99707864303517, lat: 52.9684268229554 },
    { lng: 21.95441432454334, lat: 52.9914268696091 },
    { lng: 21.88723790844203, lat: 53.0125703761052 },
    { lng: 21.89369668308604, lat: 53.0318861407372 },
    { lng: 21.93777709306556, lat: 53.0340348152438 },
    { lng: 21.93363593324407, lat: 53.0709424121384 },
    { lng: 21.91610603562589, lat: 53.0780745261002 },
    { lng: 21.90213111533293, lat: 53.0615899692452 },
    { lng: 21.86790201165742, lat: 53.0581054622674 },
    { lng: 21.81117634758532, lat: 53.1119722417957 },
    { lng: 21.7373770963803, lat: 53.11079042002734 },
    { lng: 21.69912643700328, lat: 53.1353458696191 },
    { lng: 21.70509354193337, lat: 53.1621197585109 },
    { lng: 21.67794055043964, lat: 53.2076520921877 },
    { lng: 21.69481745695846, lat: 53.2153482197505 },
    { lng: 21.64318410487786, lat: 53.2545916809825 },
    { lng: 21.65982910482308, lat: 53.2667520198253 },
    { lng: 21.66261225664489, lat: 53.305451056725 },
    { lng: 21.72897921923619, lat: 53.3154446082325 },
    { lng: 21.66563973430152, lat: 53.3397249657912 },
    { lng: 21.67867330794197, lat: 53.3727004828353 },
    { lng: 21.64082257885523, lat: 53.4257722771495 },
    { lng: 21.59496026639006, lat: 53.4847811974521 }
  ],
  pathMazowieckie: [
    { lng: 19.90969843657623, lat: 53.21887055288627 },
    { lng: 19.64227629835298, lat: 53.10393922141583 },
    { lng: 19.66388149908467, lat: 52.97107480617212 },
    { lng: 19.56957868751687, lat: 52.98362500533506 },
    { lng: 19.43833101745479, lat: 52.95256740773486 },
    { lng: 19.48606373085254, lat: 52.86662185984332 },
    { lng: 19.41546254759542, lat: 52.84271882221744 },
    { lng: 19.4425824785316, lat: 52.72020668863325 },
    { lng: 19.3477869976474, lat: 52.62641288191804 },
    { lng: 19.382028349285, lat: 52.59363914587968 },
    { lng: 19.34498489036301, lat: 52.5634271818063 },
    { lng: 19.34146878350568, lat: 52.51701998255983 },
    { lng: 19.25736739532856, lat: 52.43990462572963 },
    { lng: 19.28214037315744, lat: 52.37069667341856 },
    { lng: 19.38169113231789, lat: 52.33215230361991 },
    { lng: 19.4908552367082, lat: 52.32010915220771 },
    { lng: 19.6345704741558, lat: 52.24223392820875 },
    { lng: 19.80745638961195, lat: 52.25367029820796 },
    { lng: 19.89835781539711, lat: 52.2940014735243 },
    { lng: 20.00773619219942, lat: 52.2452462908133 },
    { lng: 20.07845427815645, lat: 52.22259557270475 },
    { lng: 20.08007610971984, lat: 52.14672454185162 },
    { lng: 20.19904678649505, lat: 52.12102987501284 },
    { lng: 20.24304228849726, lat: 52.06520917373221 },
    { lng: 20.20624262081202, lat: 52.01886363746763 },
    { lng: 20.27689254027976, lat: 51.96320307117233 },
    { lng: 20.23439574206496, lat: 51.9399140038683 },
    { lng: 20.31517002515897, lat: 51.91066735030422 },
    { lng: 20.44334607960371, lat: 51.93097735913891 },
    { lng: 20.4973903492707, lat: 51.87846192865532 },
    { lng: 20.56690288186791, lat: 51.87208609106531 },
    { lng: 20.56203785210127, lat: 51.81608619913936 },
    { lng: 20.59466254703844, lat: 51.73385207287341 },
    { lng: 20.62165504128659, lat: 51.67794586801677 },
    { lng: 20.45128504214595, lat: 51.69385589067702 },
    { lng: 20.38247311660704, lat: 51.66062441403437 },
    { lng: 20.40423192764255, lat: 51.6179040229284 },
    { lng: 20.42607785645159, lat: 51.56200635709987 },
    { lng: 20.44772848004127, lat: 51.51927957847521 },
    { lng: 20.50651582402208, lat: 51.46352033394121 },
    { lng: 20.46971578370863, lat: 51.43372536141729 },
    { lng: 20.42278829390535, lat: 51.36103125182014 },
    { lng: 20.41260226931367, lat: 51.32143697935499 },
    { lng: 20.48686939660307, lat: 51.27893151936884 },
    { lng: 20.52903150679687, lat: 51.25880560349988 },
    { lng: 20.56930437212394, lat: 51.22799591963793 },
    { lng: 20.69657918197325, lat: 51.19002121970625 },
    { lng: 20.68966577626352, lat: 51.15758529361187 },
    { lng: 20.77663579373933, lat: 51.14595282116372 },
    { lng: 20.88232068078658, lat: 51.15341958284871 },
    { lng: 20.97628685671935, lat: 51.16962897408408 },
    { lng: 21.06080360270304, lat: 51.15335273867426 },
    { lng: 21.11947192688326, lat: 51.14442578587202 },
    { lng: 21.15924161806558, lat: 51.11634977743365 },
    { lng: 21.14732882691611, lat: 51.07952565236505 },
    { lng: 21.2387503007757, lat: 51.07488128079414 },
    { lng: 21.29270429609424, lat: 51.07766187031219 },
    { lng: 21.33472798057691, lat: 51.05539719348183 },
    { lng: 21.41652856905184, lat: 51.02998767586212 },
    { lng: 21.46320676178156, lat: 51.01206456646707 },
    { lng: 21.50314133345754, lat: 51.02070650242297 },
    { lng: 21.5293177584885, lat: 51.05300971147654 },
    { lng: 21.58795339428847, lat: 51.05266444176287 },
    { lng: 21.64434062090331, lat: 51.05820153711549 },
    { lng: 21.6865798547689, lat: 51.05791058265683 },
    { lng: 21.7425723615342, lat: 51.03684526974497 },
    { lng: 21.81577269664352, lat: 51.06134225082884 },
    { lng: 21.79853018191335, lat: 51.14850228406457 },
    { lng: 21.78039179354897, lat: 51.18697844507697 },
    { lng: 21.82589876062776, lat: 51.22789657826387 },
    { lng: 21.86454354771926, lat: 51.2747516956282 },
    { lng: 21.85679416922852, lat: 51.3588295102186 },
    { lng: 21.79150155763721, lat: 51.40501987734005 },
    { lng: 21.8651643602043, lat: 51.42066399916185 },
    { lng: 21.88321760604673, lat: 51.48979511703291 },
    { lng: 21.82556978465727, lat: 51.56836517305133 },
    { lng: 21.7044781560388, lat: 51.56625076518706 },
    { lng: 21.61984277881536, lat: 51.61392482701707 },
    { lng: 21.65361220696421, lat: 51.64468558110105 },
    { lng: 21.74571123447495, lat: 51.61315057835424 },
    { lng: 21.80562430069484, lat: 51.63780391141991 },
    { lng: 21.86080486819356, lat: 51.65952345267143 },
    { lng: 21.90936790370766, lat: 51.70045737118384 },
    { lng: 21.85083039260106, lat: 51.74663570097708 },
    { lng: 21.94204317700653, lat: 51.7695633579287 },
    { lng: 21.96416416514332, lat: 51.79448658684137 },
    { lng: 21.93174719188423, lat: 51.83608752889753 },
    { lng: 21.8601398621054, lat: 51.84104480886621 },
    { lng: 21.88921151355586, lat: 51.85708226243416 },
    { lng: 21.91875336175065, lat: 51.89084473810917 },
    { lng: 21.90065478978702, lat: 51.93383710328292 },
    { lng: 21.92091197974888, lat: 51.97657109429031 },
    { lng: 21.97398228644755, lat: 51.98653204515763 },
    { lng: 22.02233710238493, lat: 51.99799429438984 },
    { lng: 22.07296641838437, lat: 52.00350590332917 },
    { lng: 22.11618792351391, lat: 52.00166375834383 },
    { lng: 22.14499231894566, lat: 51.9999350578071 },
    { lng: 22.19593341903808, lat: 52.01280686521871 },
    { lng: 22.25093189514695, lat: 52.00193329153278 },
    { lng: 22.30436632927417, lat: 52.01474869885203 },
    { lng: 22.33749340390235, lat: 51.99812732712071 },
    { lng: 22.39323478105532, lat: 52.00644500275142 },
    { lng: 22.4566224921188, lat: 52.02355582374744 },
    { lng: 22.48407205827382, lat: 52.04549543915493 },
    { lng: 22.53021115912586, lat: 52.05091818284298 },
    { lng: 22.57294099496824, lat: 52.0326362464127 },
    { lng: 22.6182004822469, lat: 52.01727591517617 },
    { lng: 22.63201822374264, lat: 52.0259789426121 },
    { lng: 22.65253581533476, lat: 52.030543327803 },
    { lng: 22.67303293209023, lat: 52.0344071641756 },
    { lng: 22.67202046878673, lat: 52.06784872829976 },
    { lng: 22.6658859241975, lat: 52.08534586479204 },
    { lng: 22.65699236272624, lat: 52.08965753949729 },
    { lng: 22.69056682879928, lat: 52.10932367724934 },
    { lng: 22.70293741747515, lat: 52.10704352994436 },
    { lng: 22.73080473119925, lat: 52.09546833997788 },
    { lng: 22.75769763224074, lat: 52.08807495007329 },
    { lng: 22.78850992234254, lat: 52.06528811033351 },
    { lng: 22.82978713626736, lat: 52.07782657314092 },
    { lng: 22.85520605789451, lat: 52.06206830028634 },
    { lng: 22.87822290328653, lat: 52.07072335022225 },
    { lng: 22.91121551415516, lat: 52.07362361427696 },
    { lng: 22.89721350195502, lat: 52.09128429058585 },
    { lng: 22.90012040218431, lat: 52.10655260921071 },
    { lng: 22.9262220115969, lat: 52.10678632941839 },
    { lng: 22.9588651916021, lat: 52.10062669496672 },
    { lng: 22.97641846210471, lat: 52.11284204455996 },
    { lng: 22.94325796384713, lat: 52.1336352317198 },
    { lng: 22.99072929867051, lat: 52.15435576889782 },
    { lng: 22.98784485929798, lat: 52.16624181461673 },
    { lng: 22.9912826333491, lat: 52.16687514730712 },
    { lng: 22.99588718429263, lat: 52.16818306113234 },
    { lng: 23.07558294364079, lat: 52.17017549211763 },
    { lng: 23.04770547953672, lat: 52.18253707967474 },
    { lng: 23.03984734460553, lat: 52.20982744883225 },
    { lng: 23.10425331823269, lat: 52.24758976685631 },
    { lng: 23.13886820530851, lat: 52.27963724495829 },
    { lng: 23.11241374877397, lat: 52.29892628590537 },
    { lng: 22.95479909577421, lat: 52.36852167934769 },
    { lng: 22.91876127292084, lat: 52.37886554453301 },
    { lng: 22.86456322143809, lat: 52.36517048254914 },
    { lng: 22.79308697246713, lat: 52.37257401830666 },
    { lng: 22.70985857151373, lat: 52.39886405849451 },
    { lng: 22.70299892469211, lat: 52.39827209331076 },
    { lng: 22.57010708767982, lat: 52.40782194953105 },
    { lng: 22.55026985100645, lat: 52.4567058238574 },
    { lng: 22.53442992897205, lat: 52.52220620035008 },
    { lng: 22.48806744674485, lat: 52.56658151135412 },
    { lng: 22.42767640158708, lat: 52.60487024014904 },
    { lng: 22.47824750806122, lat: 52.64385089289943 },
    { lng: 22.46040237120515, lat: 52.65728788014137 },
    { lng: 22.46789565841798, lat: 52.77130339454631 },
    { lng: 22.45602889016447, lat: 52.79304264461726 },
    { lng: 22.37688515795366, lat: 52.79819183341638 },
    { lng: 22.3395747212627, lat: 52.78191940685156 },
    { lng: 22.31945414167562, lat: 52.76335499735014 },
    { lng: 22.28058962615428, lat: 52.80698073553832 },
    { lng: 22.3107032697071, lat: 52.84668144070243 },
    { lng: 22.3110449425779, lat: 52.85736013566147 },
    { lng: 22.27486994759024, lat: 52.88495711625744 },
    { lng: 22.19596583689764, lat: 52.88580147134069 },
    { lng: 22.20002279796461, lat: 52.85954383478582 },
    { lng: 22.12736225089414, lat: 52.8505753124092 },
    { lng: 22.10680098069571, lat: 52.86339664144496 },
    { lng: 22.05988242085711, lat: 52.85316565888272 },
    { lng: 22.04460495178619, lat: 52.88436878611039 },
    { lng: 22.02213108180268, lat: 52.88651417323379 },
    { lng: 22.02289381455703, lat: 52.91659981092972 },
    { lng: 22.03624914687872, lat: 52.93492526559598 },
    { lng: 22.00491270408502, lat: 52.97015681350481 },
    { lng: 21.97163037228371, lat: 52.99374758523049 },
    { lng: 21.89304705063603, lat: 53.01380957112055 },
    { lng: 21.90801156244514, lat: 53.0331152456962 },
    { lng: 21.93711302746254, lat: 53.0348237463902 },
    { lng: 21.94255799731565, lat: 53.0600354834863 },
    { lng: 21.92205799179204, lat: 53.08157553627898 },
    { lng: 21.89420868173892, lat: 53.06527899237525 },
    { lng: 21.86664033435694, lat: 53.06063411057251 },
    { lng: 21.81122754291527, lat: 53.11545461008058 },
    { lng: 21.74001056083259, lat: 53.11303122228076 },
    { lng: 21.70198837248731, lat: 53.15799157295926 },
    { lng: 21.69337696852583, lat: 53.22126474892564 },
    { lng: 21.65181001112764, lat: 53.25850288659086 },
    { lng: 21.67208201751213, lat: 53.30512038664455 },
    { lng: 21.73740298220053, lat: 53.32029149631094 },
    { lng: 21.66453755001204, lat: 53.34024432735963 },
    { lng: 21.69432543905522, lat: 53.36833078551678 },
    { lng: 21.59294466495505, lat: 53.48650838868379 },
    { lng: 21.42261758863598, lat: 53.45957193193252 },
    { lng: 21.42774315532334, lat: 53.43495928381481 },
    { lng: 21.28281334461288, lat: 53.41845965398916 },
    { lng: 21.28286152146472, lat: 53.42700967900905 },
    { lng: 21.05750179320571, lat: 53.33686648483286 },
    { lng: 20.99852160518452, lat: 53.35833879883631 },
    { lng: 20.93951570387609, lat: 53.36163671240809 },
    { lng: 20.85402245102782, lat: 53.30191856374501 },
    { lng: 20.74132801229192, lat: 53.31263345726119 },
    { lng: 20.6452670054653, lat: 53.26346602624193 },
    { lng: 20.51136599243588, lat: 53.24406588066937 },
    { lng: 20.45738021383344, lat: 53.26105120531304 },
    { lng: 20.32275623102248, lat: 53.17735622525335 },
    { lng: 20.2354244433454, lat: 53.15566372508313 },
    { lng: 20.10930893116937, lat: 53.17860477265467 },
    { lng: 20.00749493421117, lat: 53.15453576627716 },
    { lng: 19.90969843657623, lat: 53.21887055288627 }
  ],
  pathLubelskie: [
    { lng: 21.80150998289106, lat: 51.07063459487756 },
    { lng: 21.82663893168496, lat: 51.03821023647011 },
    { lng: 21.80053252547083, lat: 51.02407092449081 },
    { lng: 21.87511932882057, lat: 50.79057719556373 },
    { lng: 21.88059068216991, lat: 50.78157292654381 },
    { lng: 21.88601234036744, lat: 50.77077467030536 },
    { lng: 22.06089323796519, lat: 50.81423554494028 },
    { lng: 22.07501274858984, lat: 50.81052872436571 },
    { lng: 22.16515266515228, lat: 50.7828254809469 },
    { lng: 22.19786677650448, lat: 50.73950593597742 },
    { lng: 22.15034763540153, lat: 50.67182444290086 },
    { lng: 22.16955887338478, lat: 50.65191502869148 },
    { lng: 22.23746650133893, lat: 50.64947108937743 },
    { lng: 22.2701573682061, lat: 50.61146567906284 },
    { lng: 22.3463600132509, lat: 50.60707294059694 },
    { lng: 22.41311329506078, lat: 50.57760926776324 },
    { lng: 22.52273756413074, lat: 50.56550838570203 },
    { lng: 22.58410262926038, lat: 50.47671850751789 },
    { lng: 22.41491905860444, lat: 50.3978453309639 },
    { lng: 22.5057372953531, lat: 50.34455343896413 },
    { lng: 22.68602821422274, lat: 50.35479054846451 },
    { lng: 22.60549425025125, lat: 50.30904288949063 },
    { lng: 22.62499657896143, lat: 50.30517688532515 },
    { lng: 22.71183213375958, lat: 50.30035998770099 },
    { lng: 23.00848382155383, lat: 50.28473703014095 },
    { lng: 23.18467098569667, lat: 50.39126135197529 },
    { lng: 23.25888588579008, lat: 50.35915404844756 },
    { lng: 23.37026245717302, lat: 50.39635859272966 },
    { lng: 23.42356791441051, lat: 50.34116055443909 },
    { lng: 23.40451774058365, lat: 50.29834314604962 },
    { lng: 23.5047295686176, lat: 50.28339562131292 },
    { lng: 23.51142241667505, lat: 50.25075621678427 },
    { lng: 23.55633566955298, lat: 50.25147411451788 },
    { lng: 23.62932032893628, lat: 50.3037879845218 },
    { lng: 23.68199572058053, lat: 50.34210397417984 },
    { lng: 23.71539387766855, lat: 50.3862702545113 },
    { lng: 23.9783035700567, lat: 50.40426802559971 },
    { lng: 24.0671060750267, lat: 50.47187931595951 },
    { lng: 24.11702227710504, lat: 50.63394522412202 },
    { lng: 23.98898479528395, lat: 50.80253921030206 },
    { lng: 24.17913141594268, lat: 50.84192910596146 },
    { lng: 23.97706867805531, lat: 50.96931626620545 },
    { lng: 23.87511263136799, lat: 51.15436818759883 },
    { lng: 23.65693129542657, lat: 51.32053233588178 },
    { lng: 23.72220718700235, lat: 51.40305132900644 },
    { lng: 23.61514755845317, lat: 51.52898499475658 },
    { lng: 23.55833962939149, lat: 51.73279887804114 },
    { lng: 23.65077024853731, lat: 51.77746012952792 },
    { lng: 23.62278569075525, lat: 51.83920136644461 },
    { lng: 23.70054237993337, lat: 52.00867894827012 },
    { lng: 23.645102335001, lat: 52.09845568843806 },
    { lng: 23.52530902839074, lat: 52.14626629947668 },
    { lng: 23.50119841647965, lat: 52.18301309022348 },
    { lng: 23.21411416111178, lat: 52.23595634952549 },
    { lng: 23.18674443021385, lat: 52.27462756137837 },
    { lng: 23.13431327509372, lat: 52.28290402148826 },
    { lng: 23.10669948287869, lat: 52.25799116420424 },
    { lng: 23.03136169388606, lat: 52.2140282052388 },
    { lng: 23.0325603145602, lat: 52.17593513649978 },
    { lng: 22.9766893435219, lat: 52.16971806390665 },
    { lng: 22.93160824533131, lat: 52.14156292866968 },
    { lng: 22.90942405876992, lat: 52.10034968861208 },
    { lng: 22.84670273731832, lat: 52.06531243014085 },
    { lng: 22.75711187696722, lat: 52.0885520714054 },
    { lng: 22.69663614811175, lat: 52.11308898268066 },
    { lng: 22.65486885051561, lat: 52.0884660886331 },
    { lng: 22.66760192987058, lat: 52.03405020715479 },
    { lng: 22.60339598007728, lat: 52.03329610442447 },
    { lng: 22.49953557323445, lat: 52.07470420119702 },
    { lng: 22.4669277855825, lat: 52.05894561052109 },
    { lng: 22.41900259684525, lat: 52.01632630531253 },
    { lng: 22.37803783543498, lat: 52.01333149898515 },
    { lng: 22.31718623319199, lat: 52.03410037692736 },
    { lng: 22.14729092572436, lat: 52.02566786692438 },
    { lng: 22.03878888353675, lat: 52.01989183859619 },
    { lng: 21.93870501395263, lat: 51.99224941117017 },
    { lng: 21.89149896014766, lat: 51.96933714985774 },
    { lng: 21.8735913216976, lat: 51.94245832176171 },
    { lng: 21.89348565736598, lat: 51.89349596118945 },
    { lng: 21.84610875108641, lat: 51.84716040654448 },
    { lng: 21.85465340223924, lat: 51.82904298457552 },
    { lng: 21.94205382634203, lat: 51.81543210901655 },
    { lng: 21.93852876281423, lat: 51.77587131720482 },
    { lng: 21.85390737482142, lat: 51.77142343003424 },
    { lng: 21.8447513390645, lat: 51.7409305473773 },
    { lng: 21.8937179868879, lat: 51.70263309326369 },
    { lng: 21.76776260964401, lat: 51.6446237525554 },
    { lng: 21.72107539207907, lat: 51.63608674527131 },
    { lng: 21.64842058707804, lat: 51.65653669888754 },
    { lng: 21.63365577416333, lat: 51.63688680899406 },
    { lng: 21.62471074999092, lat: 51.61538924862374 },
    { lng: 21.66791751227136, lat: 51.56828900539738 },
    { lng: 21.72012689908479, lat: 51.55704844550662 },
    { lng: 21.81318292616229, lat: 51.56515057043195 },
    { lng: 21.85520006677656, lat: 51.47324727458036 },
    { lng: 21.83984812846375, lat: 51.42140275931082 },
    { lng: 21.80529590147705, lat: 51.43068307651774 },
    { lng: 21.79340483954983, lat: 51.41106936405929 },
    { lng: 21.75282090663774, lat: 51.40604471664643 },
    { lng: 21.82985879997472, lat: 51.34622810045832 },
    { lng: 21.81757563883914, lat: 51.30513010392771 },
    { lng: 21.78857475756519, lat: 51.2964175133997 },
    { lng: 21.81024766148927, lat: 51.2210062215802 },
    { lng: 21.76924546080549, lat: 51.18371562092197 },
    { lng: 21.79104271921973, lat: 51.12086162793885 },
    { lng: 21.80150998289106, lat: 51.07063459487756 }
  ],
  pathPodkarpackie: [
    { lng: 21.88453219674697, lat: 50.77711375972167 },
    { lng: 21.7806589213319, lat: 50.64179265016651 },
    { lng: 21.2158522296101, lat: 50.338942419467 },
    { lng: 21.13909738471181, lat: 50.24472104333147 },
    { lng: 21.14683777005581, lat: 50.04594543067564 },
    { lng: 21.19566523934543, lat: 50.02114643040432 },
    { lng: 21.13834283077518, lat: 49.97992198132768 },
    { lng: 21.17980584547621, lat: 49.92024178902281 },
    { lng: 21.27003301544813, lat: 49.91671616071741 },
    { lng: 21.27447550126017, lat: 49.90169170408245 },
    { lng: 21.22059587735842, lat: 49.87563162826427 },
    { lng: 21.22203045785188, lat: 49.83537683799256 },
    { lng: 21.30027607681246, lat: 49.83415977426635 },
    { lng: 21.34399367961439, lat: 49.81220630032926 },
    { lng: 21.30138470465889, lat: 49.8014493119065 },
    { lng: 21.24341863894199, lat: 49.78285633170331 },
    { lng: 21.26838912584769, lat: 49.7379336233235 },
    { lng: 21.31544249903123, lat: 49.73115745430711 },
    { lng: 21.3579645164719, lat: 49.62094141832189 },
    { lng: 21.32366968889352, lat: 49.59767197694086 },
    { lng: 21.36762950415933, lat: 49.56054684619239 },
    { lng: 21.40525659051605, lat: 49.47277360303148 },
    { lng: 21.39504175893285, lat: 49.42457983740104 },
    { lng: 21.43812688835926, lat: 49.41010715732209 },
    { lng: 21.63147353413554, lat: 49.42564185759984 },
    { lng: 21.78427628673699, lat: 49.34926556909177 },
    { lng: 21.83758618883087, lat: 49.38531258679973 },
    { lng: 21.96249437405109, lat: 49.3285259180136 },
    { lng: 22.03036091780316, lat: 49.21523963810714 },
    { lng: 22.56828196877192, lat: 49.04358108346869 },
    { lng: 22.88414036841529, lat: 49.01351048461734 },
    { lng: 22.88730850989463, lat: 49.09748973093888 },
    { lng: 22.74374898496776, lat: 49.20151694798187 },
    { lng: 22.74996779297951, lat: 49.36360712339052 },
    { lng: 22.67874589203493, lat: 49.53013347186113 },
    { lng: 23.33634009522358, lat: 50.11625003324982 },
    { lng: 23.54025743620373, lat: 50.25862489206612 },
    { lng: 23.51074695391372, lat: 50.28563054473202 },
    { lng: 23.41238612833379, lat: 50.30203845042193 },
    { lng: 23.42851991452546, lat: 50.3422154101341 },
    { lng: 23.36971616447124, lat: 50.40521448232125 },
    { lng: 23.25086449508146, lat: 50.36018128380817 },
    { lng: 23.18397807368704, lat: 50.39949535993179 },
    { lng: 23.00632039478806, lat: 50.28743001759772 },
    { lng: 22.60896597595491, lat: 50.30913590474975 },
    { lng: 22.69353293142737, lat: 50.36069483800726 },
    { lng: 22.51021470381505, lat: 50.35137728064442 },
    { lng: 22.41126805107611, lat: 50.39604707403123 },
    { lng: 22.58372858312744, lat: 50.4797496790166 },
    { lng: 22.51953346031203, lat: 50.57742253764978 },
    { lng: 22.42467827877605, lat: 50.57441926491119 },
    { lng: 22.34106267884737, lat: 50.61413363339494 },
    { lng: 22.25793495577247, lat: 50.61610707736723 },
    { lng: 22.22957265987145, lat: 50.65361419322771 },
    { lng: 22.15418188567687, lat: 50.66060673080501 },
    { lng: 22.20009206899232, lat: 50.74897362932988 },
    { lng: 22.16392879963585, lat: 50.77135641340296 },
    { lng: 22.15946622353432, lat: 50.79649357888336 },
    { lng: 22.05171149276528, lat: 50.81579020236651 },
    { lng: 21.88453219674697, lat: 50.77711375972167 }
  ],
  pathSwietokrzyskie: [
    { lng: 20.35491111065771, lat: 51.32135388827685 },
    { lng: 20.36613477691785, lat: 51.24269432313452 },
    { lng: 20.25700297228619, lat: 51.23703234408475 },
    { lng: 20.14462764041547, lat: 51.19536510521034 },
    { lng: 20.06362509231391, lat: 51.19727885944545 },
    { lng: 20.01361064492048, lat: 51.1711171289255 },
    { lng: 19.99848990055354, lat: 51.06684299548737 },
    { lng: 20.05709860118054, lat: 51.05379704521033 },
    { lng: 20.00547199909115, lat: 50.97389694060676 },
    { lng: 19.87890029794966, lat: 51.04623624544807 },
    { lng: 19.83351995516298, lat: 50.96276242762401 },
    { lng: 19.84892529775513, lat: 50.91298988227394 },
    { lng: 19.78622488371841, lat: 50.90431252620697 },
    { lng: 19.75481443128025, lat: 50.86414347831006 },
    { lng: 19.83254422473742, lat: 50.82668509977702 },
    { lng: 19.69430731448123, lat: 50.75519165231066 },
    { lng: 19.70311892917893, lat: 50.71604788070344 },
    { lng: 19.85445368803445, lat: 50.68773450046343 },
    { lng: 19.83421602300486, lat: 50.65147128683864 },
    { lng: 19.90456076940477, lat: 50.62823232056014 },
    { lng: 19.79040767212961, lat: 50.54666685715095 },
    { lng: 19.90224076167225, lat: 50.49956721904252 },
    { lng: 20.02211549000036, lat: 50.49546666649902 },
    { lng: 20.20453544373342, lat: 50.4856084506947 },
    { lng: 20.26005895126418, lat: 50.41204421912406 },
    { lng: 20.29190605262177, lat: 50.35220286169277 },
    { lng: 20.33589776332165, lat: 50.27484348957115 },
    { lng: 20.40153324678211, lat: 50.20868830387192 },
    { lng: 20.52051677210031, lat: 50.19002558294745 },
    { lng: 20.68820013408401, lat: 50.20074760087641 },
    { lng: 20.77433611425487, lat: 50.27362240594806 },
    { lng: 20.8854570263498, lat: 50.29352975203707 },
    { lng: 21.19696428576155, lat: 50.33443329190365 },
    { lng: 21.56489586088348, lat: 50.51705659857924 },
    { lng: 21.78479802348414, lat: 50.64725280012591 },
    { lng: 21.89312811698274, lat: 50.7867018695795 },
    { lng: 21.82333343001672, lat: 51.06325029253203 },
    { lng: 21.32457736402448, lat: 51.06846229683301 },
    { lng: 21.12007116764655, lat: 51.18699927673774 },
    { lng: 20.8190020207352, lat: 51.15752460012083 },
    { lng: 20.41782160825348, lat: 51.32966966964764 },
    { lng: 20.35491111065771, lat: 51.32135388827685 }
  ]
}




// WEBPACK FOOTER //
// /Users/michaldudziak/Desktop/Projekty/Projekt-Sunroof/Sunroof/src/app/services/wojewodztwa.ts